import { render, staticRenderFns } from "./HomeClassic.vue?vue&type=template&id=21fc99dc&scoped=true"
import script from "./HomeClassic.vue?vue&type=script&lang=js"
export * from "./HomeClassic.vue?vue&type=script&lang=js"
import style0 from "./HomeClassic.vue?vue&type=style&index=0&id=21fc99dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fc99dc",
  null
  
)

export default component.exports